<div class="row page-header">
    <div class="col-12">
        <h1>Rentals <small>Track and manage equipment rentals</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <button style="display: none" class="btn btn-sm btn-secondary" [disabled]="!grid.hasItemSelected">Images</button>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Rentals'"></grid-export>
                    </form>
                </div>
            </div>
            <div style="margin-bottom: -1px">
                <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs">
                    <li [ngbNavItem]="0">
                        <a ngbNavLink>Active Rentals</a>
                    </li>
                    <li [ngbNavItem]="1">
                        <a ngbNavLink>Returned Rentals</a>
                    </li>
                </ul>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        [itemFormatter]="itemFormatter"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Equipment'" [binding]="'equipment'" [width]="180"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Images'" [binding]="'imageUrls'" [cssClass]="'cell-img'" [width]="150">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                @for (image of cell.item.imageUrls; track image; let i = $index) {
                                    <img
                                        [src]="'./Resources/Images/Rental/' + image + '?w=300'"
                                        (click)="openImage(image)"
                                        alt="RentalImage"
                                        tabindex="4"
                                        (keydown.enter)="openImage(image)"
                                    />
                                }
                            </ng-template>
                        </wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Rental Company'"
                            [binding]="'vendorId'"
                            [dataMap]="vendorMap"
                            [width]="180"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobId'" [dataMap]="jobMap" [width]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Rented By'"
                            [binding]="'rentedById'"
                            [dataMap]="allUserMap"
                            [width]="160"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Picked Up By'"
                            [binding]="'pickedUpById'"
                            [dataMap]="allUserMap"
                            [width]="160"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Picked Up Date'"
                            [binding]="'pickedUpDate'"
                            [format]="'d'"
                            [width]="160"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Scheduled Return Date'"
                            [binding]="'scheduledReturnDate'"
                            [format]="'d'"
                            [width]="160"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Returned Date'"
                            [binding]="'returnedDate'"
                            [format]="'d'"
                            [width]="160"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Maintained By'"
                            [binding]="'vendorMaintains'"
                            [dataMap]="maintMap"
                            [width]="200"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Rental Length'"
                            [binding]="'billingCycle'"
                            [dataMap]="billingCycleMap"
                            [width]="140"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Rate'" [binding]="'rate'" [format]="'C2'" [width]="110"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Rate Unit'"
                            [binding]="'rateUnit'"
                            [dataMap]="rateUnitMap"
                            [width]="130"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Hours Start'"
                            [binding]="'hoursStart'"
                            [format]="'N0'"
                            [width]="130"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Hours End'"
                            [binding]="'hoursEnd'"
                            [format]="'N0'"
                            [width]="130"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Serial Number'" [binding]="'serialNum'" [width]="130"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Is RPO'" [binding]="'isRpo'" [width]="80"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
